﻿/************************************************************************************************************************************************************************************
Plain jquery oauth client for accounts and bizagi
- Only requires jquery to work

Why jQuery
    - Built-in Promises API
    - Built in cross browser ajax API
    - Angular 1 & 2 can use jQuery
*************************************************************************************************************************************************************************************/

// Define namespace
bz = {};

bz.oAuthClient = function (params) {
    /*******************************************************************************************************************************************************
    *                                                CONSTANTS
    *******************************************************************************************************************************************************/
    var BIZAGI_OAUTH_INFO_URL = "api/oauth/bizagi/info";
    var ACCOUNTS_OAUTH_INFO_URL = "api/auth/oauth/info";

    /*******************************************************************************************************************************************************
    *                                                CLASS MEMBERS
    *******************************************************************************************************************************************************/
    var _authInfo;
    var _accessToken;
    var _profile;
    var _idToken;
    var _bizagi = {};
    var _accounts = {};

    /*******************************************************************************************************************************************************
    *                                                CONSTRUCTOR
    *******************************************************************************************************************************************************/
    _init = function (params) {
        if (!params) return;
        _setParams(params);
        _accessToken = localStorage.getItem(_getStorageAccessTokenKey());
    };

    /*******************************************************************************************************************************************************
    *                                                PRIVATE METHODS
    *******************************************************************************************************************************************************/
    var _setParams = function (params) {
        if (!params) return;
        _authInfo = {
            type: params.type, // Must be bizagi or accounts
            server: params.server,
            id: params.id || "oauth",
            scope: params.scope,
            client_id: params.client_id,
            urls: {
                wrealm: params.urls.wrealm,
                authorize: params.urls.authorize,
                logout: params.urls.logout,
                profile: params.urls.profile,
                token: params.urls.token,
                validate: params.urls.validate
            },
            saveToken: params.saveToken || false
        };
    };

    var _initAndLogin = function (loginParams) {
        loginParams = loginParams || {};
        var url = loginParams && loginParams.type == "bizagi" ? BIZAGI_OAUTH_INFO_URL : ACCOUNTS_OAUTH_INFO_URL;
        var identityServer = loginParams.identityServer;
        if (loginParams.type == "bizagi" && identityServer) url = url += "?identityServer=" + encodeURI(identityServer);
        return $.get(url)
            .pipe(function (data) {
                _init({
                    type: loginParams.type,
                    server: identityServer,
                    scope: data.scope,
                    client_id: data.client_id,
                    urls: data.urls,
                    saveToken: true
                });

                // Trigger login
                return _login(loginParams);
            });
    };

    var _login = function (loginParams) {
        loginParams = loginParams || {};
        var queryParams = loginParams.queryParams;
        return $.when(function () {
            var qs = queryParams || bz.getQueryString();
            if (_accessToken != null) return _validateToken(qs);
            if (qs["code"]) return _continueWithAuthorizationCode(qs);
            return _redirectToAuthorizePage(qs);
        }());
    };

    var _relogin = function (queryString) {
        // Try to re-logon (using SSO), but first remove old token
        localStorage.removeItem(_getStorageAccessTokenKey());
        _redirectToAuthorizePage(queryString);
    };

    var _logout = function () {
        localStorage.removeItem(_getStorageAccessTokenKey());
        var url = _getLogoutUrl();
        location.href = url;
    };

    var _redirectToAuthorizePage = function (queryString) {
        var nonce = _createNonce();
        var url = _getAuthorizeUrl(nonce, queryString);
        location.href = url;
    };

    var _continueWithAuthorizationCode = function (qs) {
        var code = qs["code"];
        var url = _authInfo.urls.token;
        if (_authInfo.type == "bizagi") url = url += "?identityServer=" + encodeURI(_authInfo.server);
        let body = {};
        body.code = code;
        body.redirect_uri = encodeURIComponent(_authInfo.urls.wrealm);

        return $.ajax({
            url: url,
            type: "POST",
            data: JSON.stringify(body) ,
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function (response) {
                _saveToken(response.access_token);
                _profile = response.profile;
                _idToken = response.id_token;
                // Redirect to remove auth code
                history.pushState(null, "", location.href.split("?")[0]);
            },
            error: function (e) {
                // On error, perform a logout
                _logout();
            }
        });
    };

    var _validateToken = function (queryString) {
        let body = {};
        body.token = _accessToken
        var url = _authInfo.urls.validate;
        if (_authInfo.type == "bizagi") url = url += "?identityServer=" + encodeURI(_authInfo.server);

        return $.ajax({
            url: url,
            type: "POST",
            data: JSON.stringify(body) ,
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function (response) {
                if (response.access_token != _accessToken) {
                    _saveToken(response.access_token);
                }
                _profile = response.profile;
                _idToken = response.id_token;
            },
            error: function (response) {
                // On error, perform a logout
                if (response.status == 401) {
                    _relogin(queryString)
                } else {
                    _logout();
                }
            }
        });

    }

    var _saveToken = function (accessToken) {
        _accessToken = accessToken;
        if (_authInfo.saveToken) {
            localStorage.setItem(_getStorageAccessTokenKey(), _accessToken);
        }
    }

    /*******************************************************************************************************************************************************
    *                                                SHARED METHODS (Implementation changes from one oauth impl to another)
    *******************************************************************************************************************************************************/

    var _getAuthorizeUrl = function (nonce, queryString) {
        var state = { nonce: nonce };
        if (queryString["redirectRoute"]) state.redirectRoute = queryString["redirectRoute"];
        state = btoa(JSON.stringify(state));
        return _impl()._getAuthorizeUrl(state);
    };

    var _getLogoutUrl = function () { return _impl()._getLogoutUrl(); };

    /*******************************************************************************************************************************************************
    *                                                UTILS
    *******************************************************************************************************************************************************/

    var _isBizagi = function () { return _authInfo.type === "bizagi"; };
    var _isAccounts = function () { return _authInfo.type === "accounts"; };
    var _impl = function () {
        if (_isBizagi()) return _bizagi;
        if (_isAccounts()) return _accounts;
        throw "Invalid implementation type";
    }

    var _getStorageAccessTokenKey = function () {
        return _authInfo.type + ":" + _authInfo.id + ":access:" + "token";
    };


    var _getRedirectUri = function (bUseFullUrlWithHashes) {
        if (bUseFullUrlWithHashes) {
            return encodeURIComponent(window.location.href);
          }

          // Try to get base element
          var base = $("base");
          if (base.length > 0 && base.attr("href").toLowerCase().indexOf("http") === 0) return base.attr("href");

          // Calculate base url
          var url = window.location.origin + window.location.pathname;
          // Remove hashes
          url = url.indexOf('#') > 0 ? url.substring(0, url.lastIndexOf('#')) : url;
          // Remove last slash if exists
          if (url.lastIndexOf("/") === url.length - 1) url = url.substring(0, url.length - 1);
          return url;
    };

    var _createNonce = function () {
        var text = "";
        var possible = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";

        for (var i = 0; i < 10; i++) {
            text += possible.charAt(Math.floor(Math.random() * possible.length));
        }
        return text;
    };

    /*******************************************************************************************************************************************************
    *                                                BIZAGI IMPLEMENTATION
    *******************************************************************************************************************************************************/
    _bizagi._getAuthorizeUrl = function (state) {
        var url = _authInfo.urls.authorize + "?response_type=" + "code" // Change this when using OPEN ID
            + "&client_id=" + encodeURIComponent(_authInfo.client_id)
            + "&state=" + encodeURIComponent(state)
            + "&redirect_uri=" + encodeURIComponent(_authInfo.urls.wrealm)
            + "&scope=" + encodeURIComponent(_authInfo.scope);
        return url;
    };

    _bizagi._getLogoutUrl = function (nonce) {
        var url = _authInfo.urls.logout;
        return url;
    };

    /*******************************************************************************************************************************************************
    *                                                ACCOUNTS IMPLEMENTATION
    *******************************************************************************************************************************************************/
    _accounts._getAuthorizeUrl = function (state) {
        var url = _authInfo.urls.authorize + "?response_type=" + "code"
            + "&client_id=" + encodeURIComponent(_authInfo.client_id)
            + "&scope=" + _authInfo.scope
            + "&redirect_uri=" + encodeURIComponent(_authInfo.urls.wrealm)
            + "&state=" + encodeURIComponent(state);

        return url;
    };

    _accounts._getLogoutUrl = function (nonce) {
        var url = _authInfo.urls.logout + "?"
            + "id_token_hint=" + _idToken
            + "&post_logout_redirect_uri=" + _authInfo.urls.wrealm;
        return url;
    };

    /*******************************************************************************************************************************************************
    *                                                CALL INITIALIZE
    *******************************************************************************************************************************************************/
    _init(params);

    /*******************************************************************************************************************************************************
    *                                                PUBLIC STUFF
    *******************************************************************************************************************************************************/
    return {
        initAndLogin: function (loginParams) {
            return _initAndLogin(loginParams);
        },

        login: function (loginParams) {
            return _login(loginParams);
        },

        logout: function () {
            return _logout();
        },

        getAccessToken: function () {
            return _accessToken;
        },

        getProfile: function () {
            return _profile;
        },

        getIdToken: function () {
            return _idToken;
        },

        refreshToken: function () {
            return _validateToken(bz.getQueryString());
        }
    };
};

/*******************************************************************************************************************************************************
*                                                GLOBAL HELPER FUNCTIONS
*******************************************************************************************************************************************************/

bz.getQueryString = function () {
    // internal parsing function
    var _parseQueryString = function (queryString) {
        var data = {}, pairs, pair, separatorIndex, escapedKey, escapedValue, key, value;
        if (queryString === null) {
            return data;
        }
        pairs = queryString.split("&");

        for (var i = 0; i < pairs.length; i++) {
            pair = pairs[i];
            separatorIndex = pair.indexOf("=");

            if (separatorIndex === -1) {
                escapedKey = pair;
                escapedValue = null;
            } else {
                escapedKey = pair.substr(0, separatorIndex);
                escapedValue = pair.substr(separatorIndex + 1);
            }

            key = decodeURIComponent(escapedKey);
            value = decodeURIComponent(escapedValue);

            if (key.substr(0, 1) === "/")
                key = key.substr(1);

            data[key] = value;
        }
        return data;
    };

    // Public function
    return function () {
        if (window.location.search && window.location.search.length > 0) {
            return _parseQueryString(window.location.search.substring(1));
        }
        if (window.location.hash.indexOf("#") === 0) {
            var url = window.location.hash;
            if (url.indexOf('?') < 0) return {};
            var queryString = url.substring(url.indexOf('?') + 1)
            return _parseQueryString(queryString);
        } else {
            return {};
        }
    }()
}


bz.getRedirectRoute = function (queryString) {
    queryString = queryString || bz.getQueryString() || {};
    var state = queryString["state"];
    if (!state) return null;

    state = atob(state);
    try {
        return JSON.parse(state).redirectRoute;
    }
    catch (e) {
        return null;
    }
}
